export default () => `${document.title}: Предложение или замечание ${new Date().toLocaleString()}`; // TODO: Переделать на более отпимальный вариант
